import { render, staticRenderFns } from "./Type15a.vue?vue&type=template&id=29397f51&"
import script from "./Type15a.vue?vue&type=script&lang=js&"
export * from "./Type15a.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports